export default __webpack_public_path__ + "static/Corporate_Responsibility_03-4677e4965c734a6fdab3f7901c22b65a.jpg";